import React from 'react';
import '../App.css';

interface ResponsiveModalProps {
    isOpen: boolean;
    onClose?: () => void;
    children: React.ReactNode;
    variant?: 'default' | 'wide';
    closeOnOverlayClick?: boolean;
}

const ResponsiveModal: React.FC<ResponsiveModalProps> = ({
    isOpen,
    onClose,
    children,
    variant = 'default',
    closeOnOverlayClick = true,
}) => {
    if (!isOpen) {
        return null;
    }

    const modalClass = variant === 'wide' ? 'modal-shell modal-shell--wide' : 'modal-shell';

    return (
        <div className="modal-overlay" onClick={closeOnOverlayClick ? onClose : undefined}>
            <div className={modalClass} onClick={(e) => e.stopPropagation()}>
                {children}
            </div>
        </div>
    );
};

export default ResponsiveModal;
